
export const blurb = "DevRacer is an online typing game inspired by TypeRacer. Type the most popular snippets from supported languages and increase your coding speed!"
